// AppRoutes.tsx
import { ThemedLayoutV2 as ThemedLayout } from "@refinedev/mui";
import { Outlet, Route, Routes } from "react-router";
import React, { useState } from "react";
import { ROUTES } from "./RouteConstant";
import { GlobalStyles, useTheme } from "@mui/material";
import { getMeterTableV2Styles } from "../styles/pages/meters/MeterTableV2.styles";
import { AuthProvider } from "../contexts/auth/AuthContext";
import TransactionsTab from "../pages/finance/TransactionsTab";
const NigeriaSmsDashboard = React.lazy(() => import("../pages/dashboard/NigeriaSmsDashboard"));
const AuthWrapper = React.lazy(() => import("./AuthWrapper"));
const ProtectedRoute = React.lazy(() => import("./ProtectedRoute"));

// Lazy-load non-critical components
const NeuronSideBar = React.lazy(() => import("../components/NeuronSideBar"));
const NeuronHeader = React.lazy(() => import("../components/header/NeuronHeader"));
const HomePage = React.lazy(() => import("../pages/HomePage"));
const Meters = React.lazy(() => import("../pages/operations/Meters"));
const EditMeterPage = React.lazy(
  () => import("../pages/operations/meters/EditMeterPage")
);
const NeuronAddMeter = React.lazy(
  () => import("../pages/operations/meters/NeuronAddMeter")
);
const NeuronAddMeterV1 = React.lazy(
  () => import("../pages/operations/meters/NeuronAddMeterV1")
);
const EditMeterV1 = React.lazy(
  () => import("../pages/operations/meters/EditMeterV1")
);
const ViewMeterWIPV1 = React.lazy(
  () => import("../components/meterWIPV1/ViewMeterWIPV1")
);
const RechargeTab = React.lazy(
  () => import("../pages/operations/recharge/RechargeTab")
);
const ForbiddenPage = React.lazy(() => import("../pages/403-Forbidden"));
const ErrorComponent = React.lazy(() =>
  import("@refinedev/core").then((mod) => ({ default: mod.ErrorComponent }))
);
const ManualCashPaymentsImportPage = React.lazy(
  () => import("../pages/bulkBonus/ManualCashPaymentsImportPage")
);
const ViewTransactions = React.lazy(
  () => import("../pages/finance/ViewTransactions")
);

export default function AppRoutes() {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const toggleDrawer = () => setIsDrawerOpen((prev) => !prev);
  const theme = useTheme();
  const styles = getMeterTableV2Styles(theme);

  return (
    <AuthProvider>
      <GlobalStyles styles={styles.globalBody} />

      <Routes>
        {/* Public Route - Login */}
        {/* <Route path="/" element={(<AuthWrapper />) as any} /> */}

        {/* Protected Routes */}
        {/* <Route element={<ProtectedRoute />}> */}
          <Route
            element={
              <ThemedLayout
                Header={() => <NeuronHeader onToggleSidebar={toggleDrawer} />}
                Sider={() => (
                  <NeuronSideBar
                    isDrawerOpen={isDrawerOpen}
                    toggleDrawer={toggleDrawer}
                  />
                )}
              >
                <Outlet />
              </ThemedLayout>
            }
          >
            <Route path={ROUTES.HOME} element={<HomePage />} />
            <Route path={ROUTES.OPERATIONS_METERS} element={<Meters />} />
            <Route path={ROUTES.ADD_METER} element={<NeuronAddMeter />} />
            <Route path={ROUTES.EDIT_METER} element={<EditMeterPage />} />
            <Route path={ROUTES.ADD_METER_V1} element={<NeuronAddMeterV1 />} />
            <Route path={ROUTES.EDIT_METER_V1} element={<EditMeterV1 />} />
            <Route
              path={ROUTES.VIEW_METERWIP_V1}
              element={<ViewMeterWIPV1 />}
            />
            <Route path={ROUTES.OPERATION_RECHARGE} element={<RechargeTab />} />
            <Route
              path={ROUTES.ADMIN_NIGERIASMSDASHBOARD}
              element={<NigeriaSmsDashboard />}
            />
            <Route path={ROUTES.FORBIDDEN} element={<ForbiddenPage />} />
            {/* <Route path={ROUTES.MANUAL_CASH_PAYMENTS_IMPORT} element={<ManualCashPaymentsImportPage />} />
            <Route path={ROUTES.TRANSACTIONS} element={<TransactionsTab />} />
            <Route path={ROUTES.VIEW_TRANSACTIONS} element={<ViewTransactions />} /> */}
            <Route path="*" element={<ErrorComponent />} />
          </Route>
        {/* </Route> */}
      </Routes>
    </AuthProvider>
  );
}
